import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import {
  BudgetVsCommitGeneralCashflow,
  BudgetVsCommitProjectCashflow,
  BudgetVsPrimeGeneralCashflow,
  BudgetVsPrimeProjectCashflow,
  CashflowFilters,
  PrimeVsCommitGeneralCashflow,
  PrimeVsCommitProjectCashflow,
} from '../framework/cash-flow/cashflow-table/cashflow.types';
import { RestRequestService } from '../restApi/rest-request.service';
import {
  REST_GET_BUDGET_VS_COMMIT_CASHFLOW,
  REST_GET_BUDGET_VS_COMMIT_CASHFLOW_BY_PROJECT,
  REST_GET_BUDGET_VS_PRIME_CASHFLOW,
  REST_GET_BUDGET_VS_PRIME_CASHFLOW_BY_PROJECT,
  REST_GET_PRIME_VS_COMMIT_CASHFLOW,
  REST_GET_PRIME_VS_COMMIT_CASHFLOW_BY_PROJECT,
  REST_PROJECTS,
} from '../restApi/RestRoutes';
import { FiscalService } from './fiscal.service';
import { serializeObject } from '@app/utils/serializeObject';

@Injectable({
  providedIn: 'root',
})
export class CashFlowService {
  constructor(
    private fiscalService: FiscalService,
    private rest: RestRequestService,
  ) {}

  getCashflowBudgetVsCommit(filters: CashflowFilters): Observable<BudgetVsCommitGeneralCashflow> {
    return this.rest.getWithObservable(
      REST_GET_BUDGET_VS_COMMIT_CASHFLOW,
      {},
      new HttpParams({ fromString: serializeObject(filters) }),
    );
  }

  getCashflowBudgetVsCommitForProject(
    projectId: number,
    filters: CashflowFilters,
  ): Observable<BudgetVsCommitProjectCashflow> {
    return this.rest.getWithObservable(
      `${REST_PROJECTS}/${projectId}/${REST_GET_BUDGET_VS_COMMIT_CASHFLOW_BY_PROJECT}`,
      {},
      new HttpParams({ fromString: serializeObject(filters) }),
    );
  }

  getCashflowBudgetVsPrime(filters: CashflowFilters): Observable<BudgetVsPrimeGeneralCashflow> {
    return this.rest.getWithObservable(
      REST_GET_BUDGET_VS_PRIME_CASHFLOW,
      {},
      new HttpParams({ fromString: serializeObject(filters) }),
    );
  }

  getCashflowBudgetVsPrimeForProject(
    projectId: number,
    filters: CashflowFilters,
  ): Observable<BudgetVsPrimeProjectCashflow> {
    return this.rest.getWithObservable(
      `${REST_PROJECTS}/${projectId}/${REST_GET_BUDGET_VS_PRIME_CASHFLOW_BY_PROJECT}`,
      {},
      new HttpParams({ fromString: serializeObject(filters) }),
    );
  }

  getCashflowPrimeVsCommit(filters: CashflowFilters): Observable<PrimeVsCommitGeneralCashflow> {
    return this.rest.getWithObservable(
      REST_GET_PRIME_VS_COMMIT_CASHFLOW,
      {},
      new HttpParams({ fromString: serializeObject(filters) }),
    );
  }

  getCashflowPrimeVsCommitForProject(
    projectId: number,
    filters: CashflowFilters,
  ): Observable<PrimeVsCommitProjectCashflow> {
    return this.rest.getWithObservable(
      `${REST_PROJECTS}/${projectId}/${REST_GET_PRIME_VS_COMMIT_CASHFLOW_BY_PROJECT}`,
      {},
      new HttpParams({ fromString: serializeObject(filters) }),
    );
  }

  getFiscalYearFilterOptions$(): Observable<{ value: number; label: string }[]> {
    return this.fiscalService.fiscalYear$.pipe(
      filter((fiscalYear) => !!fiscalYear),
      map((currentFiscalYear) => {
        const fiscalYearOptions = [];
        for (let year = currentFiscalYear - 10; year <= currentFiscalYear + 10; year++) {
          fiscalYearOptions.push({ value: year, label: `FY ${year}` });
        }
        return fiscalYearOptions;
      }),
    );
  }
}
